// v11.0.0 — first-time onboarding callout for the Sources page.
//
// Operator audit: "A user who uploads to Sources has no idea why. The
// subtitle says 'Source files available for Watermark Encode and DCP
// jobs' — but a first-timer doesn't know what either of those means."
//
// Renders a dismissible info card that explains, in one paragraph,
// what Sources are for and how they feed the rest of the pipeline.
// Once dismissed (per-workspace localStorage flag), it stays gone
// until the operator manually opens the upload guide.
import React, { useState } from 'react';
import {
  Alert, AlertTitle, IconButton, Box, Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const DISMISS_KEY = 'hhmg.sources.onboarding.dismissed';

export function isOnboardingDismissed() {
  try { return window.localStorage.getItem(DISMISS_KEY) === '1'; }
  catch (_e) { return false; }
}

export function dismissOnboarding() {
  try { window.localStorage.setItem(DISMISS_KEY, '1'); }
  catch (_e) { /* */ }
}

export function resetOnboarding() {
  try { window.localStorage.removeItem(DISMISS_KEY); }
  catch (_e) { /* */ }
}

export default function SourcesOnboardingCallout() {
  const [hidden, setHidden] = useState(() => isOnboardingDismissed());
  if (hidden) return null;
  return (
    <Alert
      severity="info"
      data-testid="sources-onboarding-callout"
      sx={{ mb: 2 }}
      action={
        <IconButton
          size="small"
          aria-label="Dismiss onboarding"
          onClick={() => { dismissOnboarding(); setHidden(true); }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    >
      <AlertTitle sx={{ fontWeight: 700 }}>Your content vault</AlertTitle>
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        Upload the master <strong>.mov</strong> or <strong>.mxf</strong> file for your film here first.
        Once compliance checks pass, the file becomes available to create a <strong>Watermark Encode</strong> (for press / awards
        / review screeners) or a <strong>Theatrical DCP</strong> (for digital cinema delivery).
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 0.5 }}>
        <Typography variant="caption" color="text.secondary">
          <strong>WM ✓</strong> = passed watermark compliance.
        </Typography>
        <Typography variant="caption" color="text.secondary">
          <strong>DCP ✓</strong> = passed DCP compliance.
        </Typography>
        <Typography variant="caption" color="text.secondary">
          <strong>?</strong> / <strong>!</strong> / <strong>✗</strong> = something needs your attention — click the chip for details.
        </Typography>
      </Box>
    </Alert>
  );
}
